module.exports = __webpack_public_path__ + "static/003_sunsmart_home_screen_foo.6248438b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project6/003_sunsmart_home_screen_foo.png
// module id = 509
// module chunks = 111663361672460